import React from 'react';
import { View, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import { RadioButton } from "react-native-paper";
// import HTML from "react-native-render-html";
// import Font from './../Colors';
// import Icon from "react-native-vector-icons/dist/Ionicons";
import {Text, Styles, ConverToTextComponent} from "./../../components/UI-Components"
import { OptionComponent } from "./../../components/"
// import { deviceHeight, deviceWidth } from '../Utils';
// import Icons from 'react-native-vector-icons/FontAwesome';
import Icon from '@material-ui/core/Icon';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import LaunchIcon from '@material-ui/icons/Launch';


// const ConverToTextComponent = ({text, isMathType, isBold}) => {
//     if(isMathType) {
//         return (
//             <>            
//             <HTML                               
//             baseFontStyle={{fontSize: 18, fontFamily: 'Spectral-SemiBold', textAlign: 'justify', fontWeight: isBold ? '500' : '400' }}
//             tagsStyles={{h3:{textAlign:'justify'},p:{textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, ol: {textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, div:{textAlign:'justify', fontFamily: 'Spectral-SemiBold'}}} html={text} />
//             </>
//         )
//     }
//     return (
//         <HTML                               
//         baseFontStyle={{fontSize: 18, fontFamily: 'Spectral-SemiBold', textAlign: 'justify', fontWeight: isBold ? '500' : '400'}}
//         tagsStyles={{h3:{textAlign:'justify'},p:{textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, ol: {textAlign:'justify', fontFamily: Font.quizFont, fontSize: 18}, div:{textAlign:'justify', fontFamily: Font.quizFont}}} html={text} />
//     )
// }

const PassageView = ({passageId, passageData, isMathType, fontSize}) => {
    if(passageId) {
        const passageInfo = passageData && passageData.length > 0 && passageData.find(p => p.id === passageId) || {};
        const passage = passageInfo.passage;        
        return <ConverToTextComponent text={passage} isMathType={isMathType} fontSize={fontSize} />
    }
    return null;
} 

const RadioButtonComponent = ({id, value, option, getAnswer, checkedAnswers, i, isMathType}) => {
    return (
        <View style={{marginBottom: 8}}>
            {/* <TouchableOpacity 
                // onPress = {() => checkedAnswers(data.id, 1)}
                
            > */}
                    <View style={{ flexDirection: 'row', alignItems: 'center',marginTop:4}}>
                <View style={{alignItems:'center',flexDirection:'row'}}>
                        <div 
                        style={{flexDirection:'row', alignItems: 'flex-start', display: 'flex'
                        
                        }}
                        onClick = {() => checkedAnswers(id, value)}
                        >                        
                            {
                                getAnswer(id) === value 
                                ? 
                                    <RadioButtonChecked
                                        
                                        style={{marginRight: 6,
                                             marginTop: 0, 
                                             color: Styles.green,
                                             width: 25,
                                             height: 25
                                            }}
                                    />
                                       
                                :
                                    <RadioButtonUnchecked
                                        style={{marginRight: 6,
                                             marginTop: 0,
                                              color: '#5A5858',
                                              width: 25,
                                              height: 25
                                            }}
                                    />
                            }                           
                            <Text style={{marginTop:0, fontFamily: 'Spectral-SemiBold', fontWeight: '500', fontSize: 18}}>({i}) </Text>
                            {/* <Text style={{width:'85%',marginTop:0, fontFamily: 'Spectral-SemiBold', fontSize: 18}}>{option || 'null'}</Text> */}
                            <View style={{width: '85%',marginLeft:10}}>
                                <ConverToTextComponent text={option} isBold isMathType={isMathType} />
                                {/* <HTML                               
                                baseFontStyle={{fontSize: 18, fontFamily: 'Spectral-SemiBold', textAlign: 'justify', fontWeight: '500'}}
                                tagsStyles={{h3:{textAlign:'justify'},p:{textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, ol: {textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, div:{textAlign:'justify', fontFamily: 'Spectral-SemiBold'}}} html={option} /> */}
                            </View>
                    </div>
                </View>
            </View>
            {/* </TouchableOpacity> */}
        </View>
    )
}
class QuestionComponent extends React.Component {
  
    getAnswer = (qId) => {       
        const answerArr = this.props.answers.filter( ans => ans.id === qId ); 
        if( answerArr.length > 0 && answerArr[0].answer_option) {
            return answerArr[0].answer_option;             
        }
        return null;
    }

    render() {
        const { data, checkedAnswers, qNo, passages } = this.props;
        const { passage_id: passageId, is_math_type: isMathType } = data || {};

        // console.log(data, checkedAnswers, this.getAnswer(data.id));

        return (
            <ScrollView 
                style={{textAlign:'justify',paddingTop:10,marginLeft:5,flexWrap:'wrap', marginHorizontal: 6, paddingBottom: 10,}}
                showsVerticalScrollIndicator={false}
            >
            
                {
                    passageId && 
                    <View style={{flex: 1, width: 480 - 50,}}>
                    <View style={styles.paraHeader}>
                        <Text style={{fontSize: 14, fontWeight: '500', color: "red", marginBottom: 4, width: '85%'}}>
                            Read the passage and answer the below questions
                        </Text>
                        <TouchableOpacity                 
                             onPress={() => {                                
                                this.props.navigation.navigate("PassageViewer", {
                                    passageId
                                })
                            }}
                        >
                        <LaunchIcon 
                            style={{
                                marginRight: 10,    
                                color: '#2f2f2f',
                                alignSelf: 'flex-end',
                                width: 26,
                                height: 26
                            }}
                           
                                                      
                        />
                        
                    </TouchableOpacity>
                    </View>                    
                    <ScrollView 
                        showsVerticalScrollIndicator={false}
                        nestedScrollEnabled={true}
                        style={{
                            flexDirection:'row',
                            height: 100 * 0.5,
                            marginBottom: 10,
                            borderWidth: 0.5,
                            borderColor: 'rgba(0,0,0,0.4)',
                            flexDirection: 'column',
                            paddingHorizontal: 6,
                            width: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.8)'                            
                        }}
                    >                 
                        <PassageView 
                            passageId={passageId}
                            passageData={passages}
                            fontSize={15}
                        />                  
                    </ScrollView>
                    </View>
                }
                <View style={{flex: 1}}>                      
                <ConverToTextComponent text={data?.question}
                  fontSize={18}
                  style={{
                      width: '100%', 
                      display: 'flex',
                      overflow: 'auto',
                      textAlign:'left',
                      fontSize: 18, 
                      color: '#000', 
                      fontWeight: '700', 
                      flexWrap: 'wrap' 
                      }}
                isMathType={isMathType} />

                    {/* <HTML 
                     baseFontStyle={{fontSize: 18, fontFamily: 'Spectral-SemiBold', textAlign: 'justify'}}
                    tagsStyles={{h3:{textAlign:'justify'},p:{textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, ol: {textAlign:'justify', fontFamily: 'Spectral-SemiBold', fontSize: 18}, div:{textAlign:'justify', fontFamily: 'Spectral-SemiBold'}}} html={data.question} /> */}
                </View>
               <View style={{marginTop:10}}>
                    <OptionComponent id={data?.id} value={1} option={data?.option1} getAnswer={this.getAnswer} checkedAnswers={checkedAnswers} i={'a'} isMathType={isMathType} />
                    <OptionComponent id={data?.id} value={2} option={data?.option2} getAnswer={this.getAnswer} checkedAnswers={checkedAnswers} i={'b'} isMathType={isMathType} />
                    <OptionComponent id={data?.id} value={3} option={data?.option3} getAnswer={this.getAnswer} checkedAnswers={checkedAnswers} i={'c'} isMathType={isMathType} />
                    <OptionComponent id={data?.id} value={4} option={data?.option4} getAnswer={this.getAnswer} checkedAnswers={checkedAnswers} i={'d'} isMathType={isMathType} />               
               </View>

            </ScrollView>
        )
    }

}

export default QuestionComponent;

const styles = StyleSheet.create({
    searchIcon: {
        marginRight: 10,    
        color: '#2f2f2f',
        alignSelf: 'flex-end'
    },
    paraHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10
    }
})